import { gql } from 'apollo-boost'

const LOCATION = gql`
  query location($id: ID!) {
    location(id: $id) {
      id
      name
      status
      businessStatus
      menuStatus
      website
      brand {
        id
        name
        businessStatus
        menu {
          id
          url
          format
          scrapingInstructions
          dishes {
            id
          }
        }
      }
      menu {
        id
        url
        format
        dishCount
        scrapingInstructions
        scrapingRejectedComment
        modifiedDate
      }
      workingHours {
        dayOfWeek
        intervals {
          openTime
          closeTime
        }
      }
      formattedAddress
      phone
      coordinates {
        latitude
        longitude
      }
      atlasId
      googlePlaceId
      googleRating
      googleUserRatingCount
      googleMapsUri
      hygieneRating
      hygieneRatingDate
      hygieneSyncDate
      modifiedDate
    }
  }
`

export default LOCATION
